import { render, staticRenderFns } from "./IconStar.vue?vue&type=template&id=339903f0&scoped=true&"
import script from "./IconStar.vue?vue&type=script&lang=js&"
export * from "./IconStar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339903f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('339903f0')) {
      api.createRecord('339903f0', component.options)
    } else {
      api.reload('339903f0', component.options)
    }
    module.hot.accept("./IconStar.vue?vue&type=template&id=339903f0&scoped=true&", function () {
      api.rerender('339903f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconStar.vue"
export default component.exports